import cls from "../../shop.module.scss";
import React, {FC} from "react";
import {ICartItemType} from "../../../../types/state";
import {quantitiesType} from "../../ShopPageCart";
import Main from "./Main";
import Footer from "./Footer";

interface IDesktopProps {
    item: ICartItemType;
    DeleteIntl: string;
    onChangeCallBack: (quantity: number, item: ICartItemType) => void;
    maxQty: number;
    quantities: quantitiesType[];
    subTotal: string;
    ProductNotAvailableIntl: string
}

const DesktopCartItems: FC<IDesktopProps> = (
    {
        item,
        DeleteIntl,
        onChangeCallBack,
        maxQty,
        quantities,
        subTotal,
        ProductNotAvailableIntl
    }
) => {
    return (
        <tr className={`${cls["cart-table__row"]} ${cls["font-for-cart-responsive-parent"]} ${cls.cart_desktop}`}>
            <Main
                item={item}
                DeleteIntl={DeleteIntl}
                onChangeCallBack={onChangeCallBack}
                quantities={quantities}
                maxQty={maxQty}
                ProductNotAvailableIntl={ProductNotAvailableIntl}
            />
            <Footer
                DeleteIntl={DeleteIntl}
                itemId={item.id}
                formattedBaseTotal={subTotal}
            />
        </tr>
    )
};

export default DesktopCartItems;
